export default __webpack_public_path__ + "static/5-384b93b02a12117a2df23a4e0c7b47cf.png";